export const APP_CONFIG_V2_EXTERNAL_ID = 'APP_CONFIG_V2';
